// eslint-disable-next-line
export default {
    name: "Auth",
    status: {
        router: true,
        redux: true
    }
}
